import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Paper } from "@mui/material";
import { toast } from "react-toastify";
import { usePlaylists } from "../../hooks/useRedux";
import PlaylistForm from "./PlaylistForm";
import { Playlist } from "../../store/slices/types";

const AddPlaylist: React.FC = () => {
  const navigate = useNavigate();
  const { createPlaylist } = usePlaylists();

  const handleSave = async (playlistData: Partial<Playlist>) => {
    try {
      const newPlaylist = {
        title: playlistData.title || "",
        description: playlistData.description || "",
        userId: playlistData.userId || "",
        items: playlistData.items || [],
        tags: playlistData.tags || [],
        isPublic:
          playlistData.isPublic !== undefined ? playlistData.isPublic : true,
        color: playlistData.color || "#667eea",
        createdAt: Date.now(),
        updatedAt: Date.now(),
      };

      await createPlaylist(newPlaylist);
      toast.success("playlist is created");
      navigate("/playlists");
    } catch (error) {
      console.error("Failed to create playlist:", error);
      toast.error(
        `❌ Failed to create playlist: ${
          error instanceof Error ? error.message : "Unknown error"
        }`
      );
    }
  };

  const handleCancel = () => {
    navigate("/playlists");
  };

  return (
    <Box>
      <Paper
        sx={{
          p: 4,
          borderRadius: 3,
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "white",
          mb: 4,
        }}
      >
        <Typography variant='h4' fontWeight='700' gutterBottom>
          Create New Playlist
        </Typography>
        <Typography variant='body1' sx={{ opacity: 0.9 }}>
          Add a new playlist to your library
        </Typography>
      </Paper>

      <Paper sx={{ p: 4, borderRadius: 3 }}>
        <PlaylistForm
          playlist={null}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      </Paper>
    </Box>
  );
};

export default AddPlaylist;

